import React from "react";
import { Wallet } from "lucide-react";

export const usd = (n, d = 2) => `$${Number(n || 0).toFixed(d)}`;
export const overBudget = (c, need) => c?.budget_usd > 0 && need > c.budget_left_usd;

const Row = ({ label, detail, value, testid }) => (
  <div className="flex items-baseline justify-between gap-3 py-1.5 border-b border-slate-100 last:border-0" data-testid={testid}>
    <div>
      <div className="text-sm text-slate-800">{label}</div>
      <div className="text-[11px] text-slate-500">{detail}</div>
    </div>
    <div className="font-mono text-sm font-semibold text-slate-900">{value}</div>
  </div>
);

const BudgetBar = ({ c }) => {
  if (!c.budget_usd) return <p className="text-[11px] text-slate-500" data-testid="cost-no-budget">Χωρίς όριο budget — ορίστε το στο Brief.</p>;
  const pct = Math.min(100, (c.spent.usd / c.budget_usd) * 100);
  return (
    <div className="space-y-1" data-testid="cost-budget-bar">
      <div className="h-2 rounded bg-slate-100 overflow-hidden">
        <div className={`h-full transition-[width] duration-500 ${pct >= 90 ? "bg-rose-500" : "bg-[#0052CC]"}`} style={{ width: `${pct}%` }} />
      </div>
      <div className="text-[11px] text-slate-600">Υπόλοιπο: <b data-testid="cost-budget-left">{usd(c.budget_left_usd)}</b> από {usd(c.budget_usd)}</div>
    </div>
  );
};

export const CostCard = ({ cost: c }) => {
  if (!c) return null;
  return (
    <aside className="border border-slate-200 rounded-lg p-4 bg-slate-50/60 space-y-3" data-testid="agency-cost-card">
      <div className="flex items-center justify-between">
        <h3 className="text-xs uppercase tracking-[0.15em] font-semibold text-slate-600 flex items-center gap-1.5"><Wallet className="w-4 h-4" /> Κόστος (εκτίμηση)</h3>
        <span className="text-[11px] text-slate-500">ανά lead ~<b data-testid="cost-per-lead">{usd(c.cost_per_lead_usd, 3)}</b></span>
      </div>
      <div>
        <Row label="AI queries" detail="1 κλήση AI" value={usd(c.queries.usd)} testid="cost-step-queries" />
        <Row label="Αναζήτηση Explee" detail={`${c.search.calls} κλήσεις · ${c.search.credits} credits`} value={usd(c.search.usd)} testid="cost-step-search" />
        <Row label="Αναζήτηση Internet" detail={`${c.web.calls} AI αναζητήσεις + LinkedIn ~${c.web.leads}`} value={usd(c.web.usd)} testid="cost-step-web" />
        <Row label="Αναζήτηση από αποθηκευμένα" detail="χωρίς χρέωση" value={usd(0)} testid="cost-step-cache" />
        <Row label="Εμπλουτισμός" detail={`${c.enrich.leads} leads · τηλέφωνα δωρεάν + AI`} value={usd(c.enrich.usd)} testid="cost-step-enrich" />
        <Row label="Έλεγχος site" detail={`${c.verify.domains} sites · scraping δωρεάν + AI`} value={usd(c.verify.usd)} testid="cost-step-verify" />
      </div>
      <div className="flex justify-between text-sm pt-1">
        <span className="text-slate-600">Σύνολο project μέσω Explee</span>
        <b className="font-mono" data-testid="cost-project-estimate">~{usd(c.project_estimate_usd)}</b>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-slate-600">Σύνολο project μέσω Internet</span>
        <b className="font-mono" data-testid="cost-project-estimate-web">~{usd(c.project_estimate_web_usd)}</b>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-slate-600">Ξοδεύτηκαν μέχρι τώρα</span>
        <b className="font-mono" data-testid="cost-spent">{usd(c.spent.usd)}</b>
      </div>
      <BudgetBar c={c} />
    </aside>
  );
};
